export enum GalleryDraggingStatusEnum {
  inactive = 0,
  pending = 1,
  active = 2,
  finished = 3,
}
